import React from 'react';

//Estilos
import '../App.css';
import { ArrowRightSquareFill } from 'react-bootstrap-icons';
import { ArrowRightCircleFill } from 'react-bootstrap-icons';

//media
import headerimg from '../media/headerimg.png';

//components

export class Headerapp extends React.Component {
    render() {
        return (
            <>
                <nav className="bg-[#aa0047] py-3 px-4 text-white sticky top-0">
                        <div className='text-center text-lg'>
                            Informacion sobre el consumo de tus tickets
                        </div>
                </nav>
            </>
        );
    }
}